import React, {useMemo, useCallback, useState} from 'react'
import _ from 'lodash';
import {Autocomplete, Skeleton, Stack, styled} from '@mui/material';
import {useQuery, useQueryClient} from '@tanstack/react-query';
import {useUser} from '../util/user.js';
import storage from '../util/storage.js';
import {useObjectMemo} from '../util/react_hooks.js';
import api from '../util/api.js';
import SCTextField from './SCTextField.js';
import SCButton from './SCButton.js';
import {closeModal, openModal} from './Modals.js';

export const useProxyUsers = ()=>{
    let [user] = useUser();
    let queryClient = useQueryClient();
    let enabled = useMemo(()=>!!user?.permissions?.includes('admin')||
        user?.proxyUser?.permissions?.includes('admin'), [user]);
    let select = useCallback(id=>{
        storage.set('sc_proxy_user', id);
        queryClient.invalidateQueries();
    }, [queryClient]);
    let deselect = useCallback(()=>{
        storage.remove('sc_proxy_user');
        queryClient.invalidateQueries();
    }, [queryClient]);
    return useObjectMemo({enabled, select, deselect});
};

const ProxyUsersModal = ()=>{
    let [value, setValue] = useState();
    let [inputValue, setInputValue] = useState('');
    let {data, isLoading} = useQuery({
        queryKey: ['adminUsers'],
        queryFn: ()=>api.admin.users(),
    });
    let options = useMemo(()=>data?.users.map(u=>({
        id: u.id,
        label: `${u.username} (${u.email})`,
    }))||[], [data]);
    let proxyUsers = useProxyUsers();
    let onSelect = useCallback(()=>{
        proxyUsers.select(value.id);
        closeModal();
    }, [value, proxyUsers]);
    let onDeselect = useCallback(()=>{
        proxyUsers.deselect();
        closeModal();
    }, [proxyUsers]);
    return <Stack direction="column" gap={2}>
      {isLoading ? <Skeleton
        variant="rounded"
        width="100%"
        height={100}
      /> : <Stack flexGrow={1}>
        <Autocomplete
          value={value}
          onChange={(__, v)=>setValue(v)}
          inputValue={inputValue}
          onInputChange={(__, v)=>setInputValue(v)}
          options={options}
          renderInput={p=><SCTextField label="משתמש" {...p}/>}
        />
      </Stack>}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <SCButton variant="contained" text="בחירת משתמש" onClick={onSelect}
          disabled={!value?.id}/>
        <SCButton variant="outlined" text="ביטול" onClick={onDeselect}/>
      </Stack>
    </Stack>;
};

export const openProxyUsersModal = ()=>openModal({
    header: 'ביצוע פעולות עבור משתמש אחר',
    content: <ProxyUsersModal/>,
});

const ProxyOverlayComp = styled(Stack, {shouldForwardProp: p=>!p.startsWith('$')})`
    background-color: #c75c25;
    color: #FFF;
    position: fixed;
    top: 0;
    right: 0;
    padding: 4px;
    border-radius: 0 0 0 4px;
    font-size: 12px;
    font-weight: bold;
    font-family: system-ui;
    z-index: 999999;
`;

export const ProxyOverlay = ()=>{
    let [user] = useUser();
    if (!user?.originalUser)
        return null;
    return <ProxyOverlayComp>
      מחובר בתור {user.username} ({user.email})
    </ProxyOverlayComp>;
};
